document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mox-combo-section]').forEach(initComboSection);
});

function initComboSection(section) {
  const addBtn = section.querySelector('[data-mox-add-to-cart]');
  if (!addBtn) return;

  const defaultText = addBtn.textContent.trim();
  const mainVariantId = addBtn.dataset.moxMainVariant;

  // --- Add to cart ---
  addBtn.addEventListener('click', async () => {
    if (!mainVariantId) return;
    const items = [{ id: Number(mainVariantId), quantity: 1 }];

    addBtn.textContent = 'Agregando combo...';
    addBtn.disabled = true;

    try {
      await addItemsToCart(items);
    } catch (err) {
      console.error('Error agregando productos al carrito:', err);
    } finally {
      addBtn.textContent = defaultText;
      addBtn.disabled = false;
    }
  });

  initProductSlider(section);
}

// --- Slider de productos ---
function initProductSlider(section) {
  const slider = section.querySelector('[data-mox-products-slider]');
  if (!slider) return;

  const track = slider.querySelector('[data-mox-track]');
  const prevBtn = slider.querySelector('[data-mox-prev]');
  const nextBtn = slider.querySelector('[data-mox-next]');
  const dotsWrap = slider.nextElementSibling?.matches('[data-mox-dots]')
    ? slider.nextElementSibling
    : null;
  const slides = track ? Array.from(track.querySelectorAll('.mox-product-item')) : [];

  const viewportEl = slider.querySelector('.mox-products-slider__viewport');
  if (!track || !prevBtn || !nextBtn || !dotsWrap || !viewportEl || !slides.length) return;

  let currentPage = 0;
  let dots = [];

  const getSlidesPerView = () => 3;

  function buildDots(totalPages) {
    dotsWrap.innerHTML = '';
    dots = [];
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mox-products-slider__dot';
      dot.setAttribute('aria-label', `Ir a la página ${i + 1}`);
      dot.addEventListener('click', () => {
        currentPage = i;
        updateSlider();
      });
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
  }

  function updateSlider() {
    const slidesPerView = getSlidesPerView();
    const totalPages = Math.max(Math.ceil(slides.length / slidesPerView), 1);
    currentPage = Math.min(currentPage, totalPages - 1);

    if (dots.length !== totalPages) buildDots(totalPages);

    const startIndex = currentPage * slidesPerView;
    const targetSlide = slides[startIndex];
    const offset = targetSlide ? targetSlide.offsetLeft : 0;
    track.style.transform = `translate3d(${-offset}px, 0, 0)`;

    const showControls = totalPages > 1;
    prevBtn.hidden = !showControls;
    nextBtn.hidden = !showControls;
    dotsWrap.hidden = !showControls;
    prevBtn.disabled = currentPage === 0;
    nextBtn.disabled = currentPage >= totalPages - 1;

    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === currentPage));
  }

  prevBtn.addEventListener('click', () => {
    currentPage = Math.max(currentPage - 1, 0);
    updateSlider();
  });

  nextBtn.addEventListener('click', () => {
    const maxPage = Math.max(Math.ceil(slides.length / getSlidesPerView()) - 1, 0);
    currentPage = Math.min(currentPage + 1, maxPage);
    updateSlider();
  });

  // --- Swipe táctil ---
  const viewport = viewportEl;
  let isDragging = false;
  let dragStartX = 0;
  let dragDeltaX = 0;
  let dragBaseOffset = 0;
  let dragPointerId = null;

  function getPageOffset(page) {
    const targetSlide = slides[page * getSlidesPerView()];
    return targetSlide ? targetSlide.offsetLeft : 0;
  }

  function onPointerDown(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    const totalPages = Math.max(Math.ceil(slides.length / getSlidesPerView()), 1);
    if (totalPages <= 1) return;

    isDragging = true;
    dragDeltaX = 0;
    dragStartX = e.clientX;
    dragBaseOffset = getPageOffset(currentPage);
    dragPointerId = e.pointerId;
    viewport.setPointerCapture(dragPointerId);
    track.style.transition = 'none';
  }

  function onPointerMove(e) {
    if (!isDragging || e.pointerId !== dragPointerId) return;
    dragDeltaX = e.clientX - dragStartX;
    track.style.transform = `translate3d(${-dragBaseOffset + dragDeltaX}px, 0, 0)`;
  }

  function onPointerUp(e) {
    if (!isDragging || e.pointerId !== dragPointerId) return;
    isDragging = false;
    track.style.transition = '';

    const maxPage = Math.max(Math.ceil(slides.length / getSlidesPerView()) - 1, 0);
    const threshold = viewport.clientWidth * 0.15;

    if (dragDeltaX <= -threshold && currentPage < maxPage) {
      currentPage += 1;
    } else if (dragDeltaX >= threshold && currentPage > 0) {
      currentPage -= 1;
    }

    // Evita que un swipe termine disparando el link del producto bajo el dedo
    if (Math.abs(dragDeltaX) > 10) track.dataset.moxSuppressClick = 'true';

    updateSlider();
  }

  viewport.addEventListener('pointerdown', onPointerDown);
  viewport.addEventListener('pointermove', onPointerMove);
  viewport.addEventListener('pointerup', onPointerUp);
  viewport.addEventListener('pointercancel', onPointerUp);

  track.addEventListener(
    'click',
    (e) => {
      if (track.dataset.moxSuppressClick === 'true') {
        e.preventDefault();
        e.stopPropagation();
        delete track.dataset.moxSuppressClick;
      }
    },
    true
  );

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateSlider, 120);
  });

  updateSlider();
}

// --- Fetch al carrito ---
async function addItemsToCart(items) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items }),
  });

  if (!res.ok) throw new Error(`Cart add failed: ${res.status}`);

  const cartRes = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
  });
  const cartData = await cartRes.json();

  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));

  const cartTrigger = document.querySelector('.hdt-site-nav_cart a[aria-controls="CartDrawer"]');
  if (cartTrigger) cartTrigger.click();
}

// --- Actualización del minicart via Sections API ---
// Listener único: se registra solo una vez aunque la sección aparezca varias veces
if (!window._moxCartListenerAdded) {
  window._moxCartListenerAdded = true;

  document.addEventListener('cart:updated', async (e) => {
    try {
      const res = await fetch('/?sections=cart-drawer');
      const data = await res.json();

      const cartDrawer = document.querySelector('#CartDrawer');
      if (cartDrawer && data['cart-drawer']) {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
        const newContent = newDoc.querySelector('#CartDrawer .hdt-dialog-drawer__inner');
        const currentContent = cartDrawer.querySelector('.hdt-dialog-drawer__inner');
        if (currentContent && newContent) currentContent.replaceWith(newContent);
        cartDrawer.setAttribute('open', '');
      }

      const cartCountEl =
        document.querySelector('hdt-cart-count') ||
        document.querySelector('.hdt-count-box');

      if (cartCountEl && e.detail?.cart?.item_count !== undefined) {
        const count = e.detail.cart.item_count;
        cartCountEl.textContent = count;
        cartCountEl.classList.toggle('hdt-hidden', count === 0);
      }
    } catch (err) {
      console.error('Error actualizando minicart:', err);
    }
  });
}
